export default __webpack_public_path__ + "static/media/cash.97abb1b4.png";